module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('p', {
    staticClass: "text-xs-center title"
  }, [_c('span', {
    staticClass: "cyan--text darken-3"
  }, [_vm._v("Оплатите подписку @bankpdfbot")])]), _vm._v(" "), _c('p', {
    staticClass: "text-xs-left text-item"
  }, [_vm._v("Это приложение представляет собой расширение функционала телеграм бота по проверке PDF чеков BankPDF bot. Реализован функционал просмотра истории проверок, объединение аккаунтов телеграм в команды, с разделением на руководителя и сотрудников (сотрудник может работать только со своими проверками, руководитель имеет возможность контролировать работу сотрудников), автоматический подсчет оборота.\n  ")]), _vm._v(" "), _c('p', {
    staticClass: "text-xs-left text-item"
  }, [_vm._v("1. PDF проверки: в этот список автоматически попадают все проверки чеков в боте (основного аккаунта и аккаунтов присоединенных сотрудников), в этом режиме доступны фильтры в верхней части экрана, а также поле контекстного поиска над списком ордеров. Имеется возможность открыть проверенный чек через ссылку \"Открыть\".\n  ")]), _vm._v(" "), _c('p', {
    staticClass: "text-xs-left text-item"
  }, [_vm._v("2. Почта: список принятых писем на почту в боте, с возможностью скачать исходный код принятого письма.\n  ")]), _vm._v(" "), _c('p', {
    staticClass: "text-xs-left text-item"
  }, [_vm._v("3. Ордера: список ордеров Bybit с возможностью подсчитать итоги и средний курс.\n  ")]), _vm._v(" "), _c('p', {
    staticClass: "text-xs-left text-item"
  }, [_vm._v("4. Статистика: при выборе этого пункта меню отображается сводная информация о проведенных проверках в графическом виде, так же доступны фильтры в верхней строке.\n  ")]), _c('p', {
    staticClass: "text-xs-left text-item"
  }, [_vm._v("5. Сотрудники: в меню можно просмотреть/добавить сотрудников в команде, для добавления сотрудника в команду нажмите кнопку + и попросите сотрудника отправить отображаемый код боту @bankpdfbot.\n  ")]), _vm._v(" "), _c('p', {
    staticClass: "text-xs-left text-item"
  }, [_vm._v("6. Поиск по базе контрагентов ByBit.\n ")]), _c('p', {
    staticClass: "text-xs-left text-item"
  }, [_vm._v("7. BlackList: список отчетов о скам аккаунтах ByBit/HTX, полученный из открытых источников.\n  ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /Users/gtirby/develop/~/vue-loader/lib/template-compiler?{"id":"data-v-2b6ad9df","hasScoped":true}!/Users/gtirby/develop/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Unpaid.vue
// module id = 414
// module chunks = 0